// extracted by mini-css-extract-plugin
module.exports = {"container":"news-content_container__b4m5V"};